<template>
  <div class="success" v-loading="loading">
    <div class="success-box">
      <div class="success-title">
        <img src="../../assets/applyDui.png" alt="" />
      </div>
      <div class="success-content">
        <p class="g">恭喜您，申请成功！</p>
        <p class="tip">您的电子保函申请已提交成功，请支付保函费用。</p>
      </div>
      <div class="corporate-account">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column prop="key" label="收款公司" width="180">
          </el-table-column>
          <el-table-column
            prop="value"
            label="中国人民财产保险股份有限公司张掖市分公司"
            width="400"
          >
            <template slot-scope="scope">
              <template v-if="scope.row.valueAdd">
                {{ scope.row.value + valueTarget(scope.row.valueTarget) }}
              </template>
              <template v-else>
                {{ scope.row.value }}
              </template>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="corporate-account-tips">
        <p>
          *支付后, 请在下方上传支付凭证 或 阳光采购系统中上传
        </p>
      </div>
      <el-button @click="toView" type="success">上传支付凭证</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      registerNumber: "",
      tableData: [
        {
          key: "对公账号",
          value: "62001650102051501612"
        },
        {
          key: "开户行",
          value: "建行张掖分行营业室"
        },
        {
          key: "转账备注",
          value: "投标登记号: ",
          valueAdd: true, // valueAdd为true时, value可进行拼接valueTarget
          valueTarget: "registerNumber"
        }
      ]
    };
  },
  methods: {
    toView() {
      this.$router.push({
        name: "applyPiccUpLoad",
        params: { registerNumber: this.registerNumber },
        query: { registerNumber: this.registerNumber }
      });
    },
    valueTarget(target) {
      return this[target];
    }
  },
  mounted() {
    // 当前界面测试地址: http://localhost:82/#/applyPicc/success?registerNumber=0770189125
    let registerNumber =
      this.$route.query.registerNumber || this.$route.params.registerNumber;
    console.log("投标登记号==>", registerNumber);
    if (registerNumber) {
      this.registerNumber = registerNumber;
    } else {
      // this.loading = true;
      this.$message({
        message: "异常!",
        type: "error"
      });
    }
  }
};
</script>

<style lang="less" scoped="scoped">
.success {
  &-box {
    width: 1200px;
    margin: 0 auto 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  &-title {
    margin-bottom: 20px;
  }
  &-content {
    margin-bottom: 20px;
    p {
      text-align: center;
      line-height: 1.2;
      &.g {
        color: #00dd62;
        font-size: 20px;
        font-weight: bold;
        margin-bottom: 10px;
      }
      &.tip {
        color: #666;
        font-size: 18px;
      }
    }
  }
}
.corporate-account {
  margin-bottom: 20px;
  &-tips {
    p {
      color: #ff4545;
      font-weight: bold;
      margin-bottom: 10px;
      text-align: center;
    }
  }
}
</style>
<style lang="less">
.el-table .cell {
  color: #333;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  cursor: default;
}
.el-table tr {
  th:nth-child(even) div {
    text-align: left;
  }
  td:nth-child(even) div {
    text-align: left;
  }
}
</style>
